import ActionSection from '@helios/ActionSection'

import LeadFormLink from './LeadFormLink.js'

// `surface` is passed through for the pages whose band sits inside narrower
// content and keeps its edge (Phase 4 PR 6 review: the Online Community
// College article); the default is ActionSection's page surface.
function CTA({surface} = {}) {
  return (
    <ActionSection
      surface={surface}
      title="Have&nbsp;questions? Talk to admissions."
      actions={
        <LeadFormLink variant="solid">Get in touch with us</LeadFormLink>
      }
      layout="split"
    >
      <p>
        Our admissions counselors are here to answer any questions and help you
        navigate the admissions process.
      </p>
    </ActionSection>
  )
}

export default CTA
